module.exports = __webpack_public_path__ + "img/NZ.db9cd78b.png";